export const MD_RENEWAL_MANAGEMENT_PREFIX = 'MD_RENEWAL_MANAGEMENT_PREFIX_';
export const SEARCH_REFRESH = MD_RENEWAL_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';
export const FETCH_ALL_MD_RENEWAL_YEARS_SUCCESS = MD_RENEWAL_MANAGEMENT_PREFIX + 'FETCH_ALL_MD_RENEWAL_YEARS_SUCCESS';
export const FETCH_TENANT_LIST = MD_RENEWAL_MANAGEMENT_PREFIX + 'FETCH_TENANT_LIST';
export const FETCH_FILE_LIST = MD_RENEWAL_MANAGEMENT_PREFIX + 'FETCH_FILE_LIST';
export const CLEAR_FILE_LIST = MD_RENEWAL_MANAGEMENT_PREFIX + 'CLEAR_FILE_LIST';
